/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { Handle, Position } from '@xyflow/react'
import { Text, Box, Divider, Flex } from '@chakra-ui/react'
import { memo } from 'react'

const CustomNode: React.FC<any> = ({
  data
}: {
  data: {
    label: string
    niveisPontuados?: Array<{ nomeNivel: string, pontuacaoTotal: number }>
  }
}) => {
  return (
    <Box
      bg="white"
      borderRadius="md"
      boxShadow="md"
      border={'2px solid var(--Azul)'}
      minW="350px"
      maxW="400px"
      minH="100px"
      px="1rem"
      py="0.75rem"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      {/* Nome do cargo */}
      <Text
        fontSize="lg"
        fontWeight="bold"
        textAlign="center"
        color={'var(--Azul)'}
        whiteSpace="normal"
        wordBreak="break-word"
        mb="0.5rem"
      >
        {data.label}
      </Text>

      <Divider borderColor="var(--Azul)" mb="0.5rem" />

      <Flex
        wrap="wrap"
        align="center"
        justify="center"
        gap="0.5rem"
        w="100%"
        fontSize="sm"
        fontWeight="500"
        color="gray.700"
      >
        {data.niveisPontuados?.map((nivel, idx) => (
          <Flex key={idx} align="center">
            <Text whiteSpace="nowrap">
              {nivel.nomeNivel.replaceAll('_', ' ')}: {nivel.pontuacaoTotal}
            </Text>
            {idx < (data.niveisPontuados?.length ?? 0) - 1 && (
              <Text mx="0.5rem" color="gray.400" fontWeight="normal">|</Text>
            )}
          </Flex>
        ))}
      </Flex>

      <Handle type="target" position={Position.Top} style={{ background: 'var(--Azul)' }} />
      <Handle type="source" position={Position.Bottom} style={{ background: 'var(--Azul)' }} />
    </Box>
  )
}

export default memo(CustomNode)
